import React from "react"
import {Link, useParams} from "react-router-dom"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {useAccessToken} from "../../services/auth"
import {getManagedSolutionsApplication} from "../../resources/managedSolutions"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import TitleBar, {MetaItemProps} from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import {startCase} from "lodash"
import moment from "moment"
import HorizontalField from "../../components/HorizontalField/HorizontalField"

export default function ManagedSolutionsApplicationPage() {
	const {applicationId = ""} = useParams<{applicationId: string}>()
	const accessToken = useAccessToken()
	const [refreshToken, refresh] = useRefreshToken()
	const asyncResult = useAsyncResult(
		() => getManagedSolutionsApplication(accessToken, applicationId),
		[refreshToken, applicationId]
	)

	return (
		<>
			<AsyncResultComponent asyncResult={asyncResult} refresh={refresh}>
				{({value: application}) => {
					const {attributes, relationships} = application.data
					const statusDisplay = attributes.status ? startCase(attributes.status) : undefined
					const createdAt = attributes.createdAt ? moment(attributes.createdAt).format("L LT") : undefined
					const customerId = relationships?.customer?.data?.id
					const applicationFormId = relationships?.applicationForm?.data?.id

					const meta: MetaItemProps[] = [
						...(statusDisplay ? [{text: statusDisplay}] : []),
						...(customerId
							? [
									{
										text: "Customer",
										icon: "user-geometric-action-money-fund---users",
										path: `/managed-solutions/customers/${customerId}`,
									} as MetaItemProps,
							  ]
							: []),
						...(applicationFormId
							? [
									{
										text: "Application Form",
										icon: "common-file-text---files-&-folders",
										path: `/managed-solutions/application-forms/${applicationFormId}`,
									} as MetaItemProps,
							  ]
							: []),
					]

					return (
						<>
							<TitleBar
								title={`Application ${application.data.id}`}
								breadcrumbs={[{text: "Applications", path: "/managed-solutions/applications"}]}
								meta={meta.length > 0 ? meta : undefined}
							/>

							<MainSection>
								<div className="columns">
									<div className="column is-4">
										<div className="card">
											<div className="card-header">
												<p className="card-header-title">Application Details</p>
											</div>
											<div className="card-content">
												<HorizontalField label="Application ID">
													<input type="text" className="input is-static" readOnly value={application.data.id} />
												</HorizontalField>
												{statusDisplay && (
													<HorizontalField label="Status">
														<input type="text" className="input is-static" readOnly value={statusDisplay} />
													</HorizontalField>
												)}
												{createdAt && (
													<HorizontalField label="Created At">
														<input type="text" className="input is-static" readOnly value={createdAt} />
													</HorizontalField>
												)}
												{customerId && (
													<HorizontalField label="Customer">
														<Link className="link" to={`/managed-solutions/customers/${customerId}`}>
															{customerId}
														</Link>
													</HorizontalField>
												)}
												{applicationFormId && (
													<HorizontalField label="Application Form">
														<Link className="link" to={`/managed-solutions/application-forms/${applicationFormId}`}>
															{applicationFormId}
														</Link>
													</HorizontalField>
												)}
												<HorizontalField label="User IDs">
													<div>
														{attributes.userIds.map((userId, index) => (
															<div key={index} style={{marginBottom: "0.5rem"}}>
																{userId}
															</div>
														))}
													</div>
												</HorizontalField>
											</div>
										</div>
									</div>
								</div>
							</MainSection>
						</>
					)
				}}
			</AsyncResultComponent>
		</>
	)
}
